import collectionSerializer from '@shared/js/serializers/collectionSerializer.js'
import { get as getStorage, set as setStorage } from 'idb-keyval'
import { isArray, clone } from '@helpers/utils.js'
import { useSessionStorage } from '@vueuse/core'
import { computed, watch, ref } from 'vue'
import { GAME_ID } from '@config/game.js'
import { isEMH } from '@config'
import {
  SS_COLLECTIONS_FOLLOWING_REFRESHED,
  LS_COLLECTIONS_FOLLOWING,
} from '@config/localstorage.js'

const followedCollectionsState = ref([])
const fetchedFollowedCollectionsState = useSessionStorage(
  SS_COLLECTIONS_FOLLOWING_REFRESHED,
  null
)

async function init() {
  try {
    const state = await getStorage(LS_COLLECTIONS_FOLLOWING)
    if (state) {
      followedCollectionsState.value = state
    }
  } catch (error) {
    console.error(error)
  }
}

if (process.env.NODE_ENV !== 'test') {
  init()

  watch(followedCollectionsState, (newState) => {
    setStorage(LS_COLLECTIONS_FOLLOWING, clone(newState))
  })
}

export default function () {
  const followedCollections = computed(() =>
    isEMH
      ? followedCollectionsState.value.filter((m) => m.game_id === GAME_ID)
      : followedCollectionsState.value
  )
  const fetchedFollowedCollections = computed(() =>
    JSON.parse(fetchedFollowedCollectionsState.value || '[]')
  )

  function clearMyFollowedCollections() {
    followedCollectionsState.value = []
  }

  function setMyFollowedCollections(_following) {
    const data = collectionSerializer.transform({ data: _following }).data

    followedCollectionsState.value = data

    return data
  }

  // use game and collection id
  function addCollectionFollow(collectionId, collectionData) {
    if (isArray(followedCollectionsState.value)) {
      const followed = followedCollectionsState.value.find(
        (sub) => sub && sub.id === parseInt(collectionId)
      )

      if (!followed) {
        setMyFollowedCollections([
          ...followedCollectionsState.value,
          collectionData,
        ])
      }
    } else {
      setMyFollowedCollections([collectionData])
    }
  }

  // use game and collection id
  function removeCollectionFollow(collectionId) {
    const updated = followedCollectionsState.value.filter(
      (followed) => followed && followed.id !== parseInt(collectionId)
    )
    setMyFollowedCollections(updated)
  }

  function hasFollowForUser(userNameId) {
    return computed(() =>
      followedCollections.value?.some(
        (collection) => collection.submitted_by.name_id === userNameId
      )
    )
  }

  function setFetchedFollowedCollections(gameNameId) {
    fetchedFollowedCollectionsState.value = JSON.stringify([
      ...new Set([...fetchedFollowedCollections.value, gameNameId]),
    ])
  }

  return {
    setFetchedFollowedCollections,
    fetchedFollowedCollections,
    clearMyFollowedCollections,
    setMyFollowedCollections,
    removeCollectionFollow,
    addCollectionFollow,
    followedCollections,
    hasFollowForUser,
  }
}
